import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const schedulesApiRoutes = {
    list: apiDataManagerBaseURL + "schedules/",
    listDraft: apiDataManagerBaseURL + "schedulesdraft/",
    load: apiDataManagerBaseURL + "schedules/",
    loadByLine: apiDataManagerBaseURL + "schedules/byline/",
    countActiveNetwork: apiDataManagerBaseURL + "schedules/count/",
    countDraft: apiDataManagerBaseURL + "schedulesdraft/count/",
    create: apiDataManagerBaseURL + "schedules/",
    createDraft: apiDataManagerBaseURL + "schedulesdraft/",
    update: apiDataManagerBaseURL + "schedules/",
    updateDraft: apiDataManagerBaseURL + "schedulesdraft/",
    delete: apiDataManagerBaseURL + "schedules/",
    deleteDraft: apiDataManagerBaseURL + "schedulesdraft/"
};

export class ScheduleAPI {
    static list(planningEdition, provider = '') {
        const url = new URL(schedulesApiRoutes.list);

        return API.authenticatedRequest({
            url: provider === '' ? `${url}?planningEditionsEncoded=${planningEdition}` : `${url}?planningEditionsEncoded=${planningEdition}&provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static listDraft(draftPlanningEdition, provider = '') {
        const url = new URL(draftPlanningEdition, schedulesApiRoutes.listDraft);

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static load(planningEdition, id) {
        const url = new URL(`${planningEdition}/${id}`, schedulesApiRoutes.load);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static loadByLine(planningEdition, networkEdition, id) {
        const url = new URL(`${planningEdition}/${networkEdition}/${id}`, schedulesApiRoutes.loadByLine);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static countActive(planningEdition, providerId = '') {
        const url = new URL(planningEdition, schedulesApiRoutes.countActiveNetwork);

        return API.authenticatedRequest({
            url: providerId === '' ? url : `${url}?providerId=${providerId}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static countDraft(draftPlanningEdition, providerId) {
        const url = `${schedulesApiRoutes.countDraft}${draftPlanningEdition}/${providerId}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static create(planningEdition, schedule) {
        const url = new URL(planningEdition, schedulesApiRoutes.create);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(schedule)
        });
    }

    static createDraft(draftPlanningEdition, schedule) {
        const url = `${schedulesApiRoutes.createDraft}${draftPlanningEdition}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(schedule)
        });
    }

    static update(planningEdition, id, schedule) {
        const url = new URL(`${planningEdition}/${id}`, schedulesApiRoutes.update);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(schedule)
        });
    }

    static updateDraft(draftPlanningEdition, id, schedule) {
        const url = `${schedulesApiRoutes.updateDraft}${draftPlanningEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(schedule)
        });
    }

    static delete(planningEdition, id) {
        const url = new URL(`${planningEdition}/${id}`, schedulesApiRoutes.delete);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteDraft(draftPlanningEdition, id) {
        const url = `${schedulesApiRoutes.deleteDraft}${draftPlanningEdition}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/datamanager/ScheduleAPI.js